import gql from 'graphql-tag'

export const UpdateTrustedContactMutation = gql`
  mutation UpdateTrustedContactMutation($input: UpdateTrustedContactInput!) {
    updateTrustedContact(input: $input) {
      worker {
        id
      }
    }
  }
`
